module.exports = __webpack_public_path__ + "static/media/fire.346658eb.mp4";